"use client";
import ReactMarkdown from "react-markdown";
import Navbar from "@/src/components/Navbar";
import "@/src/styles/QuarkleDesign.css";
import { changeLogs } from "@/src/components/changeLog/ChangeLogs";

// A date-only string must read as a local calendar date, never UTC-shifted.
const formatDay = (date) =>
  new Date(`${date}T00:00:00`).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

// Docs and blog links open beside the app, not over it.
export const markdownParts = {
  p: ({ children }) => <>{children}</>,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
};

export default function Changelog() {
  return (
    <div className="qk-editor min-h-screen w-full" style={{ background: "var(--qk-paper)", color: "var(--qk-ink)" }}>
      <Navbar />
      <main className="qk-changelog">
        <header className="qk-changelog__mast">
          <span className="qk-caps" style={{ color: "var(--qk-pink-deep)" }}>your quarkle · what&apos;s new</span>
          <h1 className="qk-changelog__title">the changelog.</h1>
          <p className="qk-changelog__deck">
            what shipped, by day. product changes only; links go to the docs.
          </p>
        </header>
        {changeLogs.map((day) => (
          <section key={day.date} className="qk-changelog__day">
            <time className="qk-changelog__date" dateTime={day.date}>
              {formatDay(day.date)}
            </time>
            <div className="qk-changelog__body">
              {day.groups.map((group) => (
                <div key={group.heading} className="qk-changelog__group">
                  <h2 className="qk-changelog__heading">{group.heading}</h2>
                  <ul className="qk-changelog__items">
                    {group.items.map((item) => (
                      <li key={item}>
                        <ReactMarkdown components={markdownParts}>{item}</ReactMarkdown>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </section>
        ))}
      </main>
    </div>
  );
}
